import React from "react";

import AppPlaceholderPhoto from "@common/assets/images/shared-icons/app-icon-placeholder.svg";
import ChromeAppPlaceholderPhoto from "@common/assets/images/shared-icons/purple-app-icon-placeholder.svg";
import { HelperText } from "@common/components/HelperText/HelperText";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { App } from "@common/models";
import { vars } from "@common/styles";
import { getOSImage } from "@common/util/contentResolvers";
import * as Styled from "main/pages/shared/components/TicketMobileViewHeader/TicketMobileViewHeader.styles";

interface Props {
  app: App | undefined;
}

export default function TicketMobileViewHeader({ app }: Props) {
  if (!app) return null;

  return (
    <Styled.TicketMobileViewHeader>
      <HelperText>{"Mobile preview — visit on desktop for more."}</HelperText>
      <Styled.TicketMobileViewHeaderApp>
        <img
          src={app.logo_url ? app.logo_url : app.is_extension ? ChromeAppPlaceholderPhoto : AppPlaceholderPhoto}
          width={28}
          height={28}
          style={{ borderRadius: "0.8rem", objectFit: "cover", marginRight: "1rem" }}
          alt={"App logo"}
        />
        <Paragraph
          p1
          color={vars.colors.grey20}
        >
          {app.name}
        </Paragraph>
        <img
          src={getOSImage(app.platform)}
          style={{ marginLeft: "1rem" }}
          width={20}
          height={20}
          alt={"OS logo"}
        />
      </Styled.TicketMobileViewHeaderApp>
      <Styled.TicketMobileViewHeaderSeparator />
    </Styled.TicketMobileViewHeader>
  );
}
